var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 16,
    viewBox: "0 0 51 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.4595,
    y: 9.57104,
    width: 4.21941,
    height: 2.53165,
    rx: 1,
    transform: "rotate(-180 37.4595 9.57104)",
    fill: "#C6E7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1936 8.57104C36.1936 9.12333 35.7459 9.57104 35.1936 9.57104L1.11766 9.57104C0.565372 9.57104 0.117657 9.12333 0.117657 8.57104L0.117657 8.0394C0.117657 7.48712 0.565373 7.0394 1.11766 7.0394L35.1936 7.0394C35.7459 7.0394 36.1936 7.48712 36.1936 8.0394L36.1936 8.57104Z",
    fill: "#C6E7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7944 9.27802L34.1266 14.7095C33.2136 15.0723 32.3795 14.0388 32.9269 13.223L35.8221 8.90835C36.0471 8.57313 36.0484 8.13552 35.8255 7.79894L32.9059 3.391C32.3638 2.57258 33.2025 1.54453 34.1131 1.91116L47.7986 7.42107C48.636 7.75821 48.6333 8.94464 47.7944 9.27802Z",
    fill: "#C6E7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.56c68aafe836887dea4c6eefa2a3cf56.svg";
export { ForwardRef as ReactComponent };